import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Input } from "reactstrap";
import { getTourGuides } from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';

const TourGuideIndex = () => {
    const dispatch = useDispatch();
    const {
        AuthReducer: { auth },
        indexReducer: { TourGuideList, tourGuideCount = 0,
        },
        PermissionReducer: { allowedPermissions = [] },
    } = useSelector((state) => state);

    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const [category, setCategory] = useState("");
    const [tourGuideCategories, setTourGuideCategories] = useState([]);
    const [sort, setSort] = useState('desc');
    const [paginate, setPaginate] = useState(10);
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;

    useEffect(() => {
        if (auth?.token) {
            dispatch(getTourGuides(auth.token, paginate, page, search, category, sort));
        }
    }, [auth, paginate, page, search, category, sort]);

    console.log("TourGuideList => ", TourGuideList?.TourCategorys)
    useEffect(() => {
        const fetchTourGuideCategories = async () => {
            try {
                const { data } = await axios.get(`/api/admin/v1/tour-guide-list`, {
                    headers: {
                        Authorization: `Bearer ${auth?.token}`,
                    },
                });
                setTourGuideCategories(data?.TourGuideCategories || []);
            } catch (error) {
                console.error("Error fetching categories", error);
                toast.error("Failed to load categories.");
            }
        };
        if (auth?.token) {
            fetchTourGuideCategories();
        }
    }, [auth]);

    const handleDel = async (id) => {
        if (window.confirm("Are you sure you want to delete this tour guide?")) {
            try {
                const { data } = await axios.delete(`/api/admin/v1/tour-guide-delete/${id}`, {
                    headers: {
                        Authorization: `Bearer ${auth?.token}`,
                    },
                });
                toast.success(data.message);
                dispatch(getTourGuides(auth.token, paginate, page, search, category, sort));
            } catch (error) {
                console.error("Error deleting tour guide", error);
                toast.error("Something went wrong while deleting.");
            }
        }
    };

    // CSV data setup
    // const csvHead = [['Category', 'Name', 'Location', 'Languages', 'Description']];
    // const csvData = TourGuideList.map((guide) => [
    //     guide?.tour_guide_category?.category_name,
    //     guide?.name,
    //     guide?.location,
    //     guide?.languages.join(', '),
    //     guide?.description,
    // ]);
    // const exportData = csvHead.concat(csvData);

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <div className="mb-4 d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 text-white fs-4">Tour Guide List</h5>
                        {allowedPermissions?.some?.((item) => item?.permission?.permission === "create") && (
                            <Link to="/add-tour-guide">
                                <Button className="bg-white text-black" size="sm">
                                    <span className="me-2"><MdAdd size={22} /></span>
                                    Add Tour Guide
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2 my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>
                <div className="row">
                    <div className="col-md-2 mb-2">
                        <Input size="sm" value={search} placeholder='Search By Name' onChange={({ target: { value } }) => setSearch(value)} />
                    </div>
                    <div className="col-md-2">
                        <Input size="sm" value={category} type="select" name="category" onChange={({ target }) => setCategory(target.value)}>
                            <option value="">Select Category</option>
                            {tourGuideCategories?.map?.((item) => (
                                <option value={item.id} key={item.id}>
                                    {item?.category_name}
                                </option>
                            ))}
                        </Input>
                    </div>
                    <div className={`col-md-2 ${allowedPermissions?.some?.((item) =>
                        item?.permission?.moduleType === "TOUR_GUIDES" &&
                        item?.permission?.permission === "export"
                    ) ? "offset-md-5" : "offset-md-6"}`}>
                        <Input type="select" size="sm" value={sort} onChange={({ target }) => setSort(target.value)}>
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </Input>
                    </div>
                    {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "TOUR_GUIDES" && item?.permission?.permission === "export") && (
                        <div className="col-md-1 mb-2">
                            {/* <CSVLink
                                filename="tour-guides.csv"
                                className="text-black ms-1"
                                title="Export To CSV"
                                data={exportData}
                            >
                                <BiSolidFileExport size={25} />
                            </CSVLink> */}
                        </div>
                    )}
                    <div className="col-md-12">
                        <Table hover responsive>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Languages</th>
                                    {/* <th>Description</th>
                                    <th>Experience</th> */}
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(TourGuideList?.TourCategorys) && TourGuideList?.TourCategorys.length > 0 ? (
                                    TourGuideList?.TourCategorys?.map((guide) => (
                                        <tr key={guide?.id || Math.random()}>
                                            <td>{guide?.id ?? "N/A"}</td>
                                            <td>{guide?.name ?? "N/A"}</td>
                                            <td>{guide?.email ?? "N/A"}</td>
                                            <td>{guide?.mobile ?? "N/A"}</td>
                                            <td>{guide?.state || "N/A"}</td>
                                            <td>{guide?.city || "N/A"}</td>
                                            <td>{guide?.Language ?? "N/A"}</td>
                                            <td>{guide?.status === 1 ? "Active" : "Inactive"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8">No data available</td>
                                    </tr>
                                )}
                            </tbody>

                        </Table>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                        <div className="col-md-2">
                            <Input type="select" id="paginate" onChange={e => setPaginate(Number(e.target.value))} value={paginate} className="paging custom-select custom-select-page m-0">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                            </Input>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <Pagination setPage={setPage} page={page} data={TourGuideList} totalPage={Math.ceil(tourGuideCount / paginate)} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TourGuideIndex;
